module.exports = __webpack_public_path__ + "static/media/v2_page_theme_color.e7214da6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/lite/v2_page_theme_color.jpg
// module id = 779
// module chunks = 0